module.exports = __webpack_public_path__ + "img/u402.df2cb91e.svg";